import { memo, useCallback, useMemo } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { IconButton, ListRow, Tag, WithTooltip } from 'basic-components';
import { Exit } from 'basic-components/icons';
import { StatusesEnums } from 'dashboard-services/api/statuses';
import TimeService from 'dashboard-services/services/TimeService';
import { StatusIcon, StatusStyleService } from 'primary-components';

import { statusesActions } from 'actions/modules/statuses';
import { statusesQueries } from 'queries/modules/statuses';

import { When } from 'react-if';

import classNames from 'classnames';
import './Row.scss';

const NCSV = "NCSV"
const EMPTY_ARRAY = [];
const EMPTY_OBJ = {};

// eslint-disable-next-line
const Row = ({ name = "", fileName, fileType, status = undefined, startTime = "", style = EMPTY_OBJ, isScrolling, setExpanded, warnStatuses = EMPTY_ARRAY, scrollCont, jobId, type, version, payload = EMPTY_OBJ, componentStatuses = EMPTY_ARRAY }) => {
  const dispatch = useDispatch(),
        definedTime = useSelector(state => state.myAccountState.settingsState.definedTime),
        parsedTime = useMemo(() => TimeService.getUserFormattedDateTime(startTime, definedTime), [definedTime, startTime]),
        goToDetails = useCallback(() => {
          batch(() => {
            dispatch(statusesActions.addToHistory())
            dispatch(statusesActions.changeValue(statusesActions.MODES.DETAILS, "mode"))
            dispatch(statusesActions.changeValue(jobId, "jobId"))
          })
        }, [dispatch, jobId]),
        localFileName = useMemo(() => type === StatusesEnums.STATUS_TYPE.PIPELINE ? name + (version ? " v."+version : "") : fileName, [fileName, name, type, version]),
        isNCSV = useMemo(() => fileType=== NCSV, [fileType]),
        tagStyle = useMemo(() => StatusStyleService.getTagStatusStyle(status), [status]),
        tagLabelProps = useMemo(() => ({ style: StatusStyleService.getTagLabelStatusStyle(status) }), [status]),
        getNonETLId = useCallback(() => statusesActions.getNonETLId(payload, componentStatuses), [payload, componentStatuses]),
        openItemRaw = statusesQueries.useOpenBasedOnStatusType({ jobId, param: type === StatusesEnums.STATUS_TYPE.ETL ? (payload?.groupName || name) : getNonETLId(), type }),
        openItem = useCallback(e => {
          e.preventDefault()
          e.stopPropagation()
          openItemRaw()
        }, [openItemRaw])

  return (
    <ListRow 
        className={classNames(
          "statuses__history__body__list__row",
          { "statuses__history__body__list__row--is-ncsv": isNCSV }
        )}
        height={32}
        onClick={goToDetails} 
        scrollContRef={scrollCont}
    >
      <div className="statuses__history__body__list__row__status">
        <StatusIcon
            status={status}
            warnStatuses={warnStatuses}
        />
      </div>
      <div className="statuses__history__body__list__row__date">
        {parsedTime.split(" ")[0]}
      </div>
      <div className="statuses__history__body__list__row__time">
        {parsedTime.split(" ")[1]}
      </div>
      <div className="statuses__history__body__list__row__name">
        {localFileName}
      </div>
      <When condition={isNCSV}>
        {() => (
          <Tag 
              isEditable={false}
              labelProps={tagLabelProps}
              style={tagStyle}
          >
            NCSV
          </Tag>
        )}
      </When>
      <WithTooltip
          data-place="top"
          short
          text="Open"
      >
        <IconButton
            className="statuses__history__body__list__row__exit"
            onClick={openItem}
        >
          <Exit
              color="blue-bright"
              height={16}
              width={16}
          />
        </IconButton>
      </WithTooltip>
    </ListRow>
  )
}

Row.propTypes = {
  componentStatuses: PropTypes.array,
  name: PropTypes.string,
  payload: PropTypes.object,
  startTime: PropTypes.string,
  status: PropTypes.string,
  style: PropTypes.object,
  warnStatuses: PropTypes.array,
}

export default memo(Row);